import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import './ButtonDropdown.scss';

// Menu item role → i18n key (resolved with t() at render, so labels follow
// the active language). change_role reuses the existing shared roles key.
const ROLE_LABEL_KEYS = {
    change_role: 'roles.change_role',
    remove_invite: 'roles.remove_invite',
};

function ButtonDropdownInvite({ roleText, inviteId, menuItems = [] }) {
    const { t } = useTranslation();
    const [isOpen, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleItemClick = (callback, newMemberRole) => {
        if (typeof callback === 'function') {
            callback(inviteId, newMemberRole);
        }
        setOpen(false);
    };

    return (
        <div ref={ref} className={`btn-dropdown_wrap`}>
            <button
                type="button"
                className={`btn-dropdown_btn invited ${isOpen ? 'selected' : ''}`}
                onClick={() => setOpen(prev => !prev)}
            >
                <div className="left-part-text">
                    {roleText}
                    {/* <span className="left-part-subtext">(Invited)</span> */}
                </div>
            </button>

            {isOpen && (
                <ul className="btn-dropdown_menu invited">
                    {menuItems.map((item, index) => {
                        if (item.line) {
                            return <div key={index} className="horizontal-line"></div>;
                        } else {
                            return (
                                <li key={index} className="btn-dropdown_menu-item">
                                    <button
                                        type="button"
                                        className={`btn-dropdown_menu-item-btn ${item.locked ? 'locked' : ''}`}
                                        onClick={() => handleItemClick(item.onClick, item.role)}
                                    >
                                        {/* {item.role === 'revoke' ? <svg className="remove" width="23px" height="23px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g> <path d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M10 11.5V16.5M14 11.5V16.5M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg> : ''} */}
                                        {t(ROLE_LABEL_KEYS[item.role] ?? ROLE_LABEL_KEYS.remove_invite)}
                                    </button>
                                </li>
                            )
                        }
                    })}
                </ul>
            )}
        </div>
    );
}

export default ButtonDropdownInvite;







































// import { useEffect, useState } from 'react';

// import './Modal.scss';

// const Modal = ({
//     modalClass = '',
//     onShouldRender = null,
//     isOpen = false,
//     onCancel = null,
//     children,
//     isModalFullScreen = false,
// }) => {
//     const [shouldRender, setShouldRender] = useState(isOpen);
//     const [animationClass, setAnimationClass] = useState('');

//     useEffect(() => {
//         if (isOpen) {
//             onShouldRender?.();
//         }
//     }, [shouldRender]);

//     const handleOverlayClick = (e) => {
//         if (e.target === e.currentTarget) {
//             onCancel?.();
//         }
//     };

//     /* Close on ESC */
//     useEffect(() => {
//         if (!isOpen) return;

//         const handleKey = (e) => {
//             if (e.key === 'Escape' || e.key === 'Esc') {
//                 e.preventDefault();
//                 onCancel?.();
//             }
//         };
//         document.addEventListener('keydown', handleKey);
//         return () => document.removeEventListener('keydown', handleKey);
//     }, [isOpen, onCancel]);

//     if (!shouldRender) return null;

//     /* Modal markup (via portal so it sits above rest of DOM) */
//     return (
//         <div
//             className={`modal ${modalClass}`}>
//             <div className={`modal-overlay ${animationClass}`} onClick={handleOverlayClick}></div>
//             <div className={`modal-content ${animationClass} ${isModalFullScreen ? 'modal-fullscreen' : ''}`} onAnimationEnd={handleAnimationEnd}>
//                 {children}
//             </div>
//         </div>
//     );
// };

// export default Modal;
